<template>
  <pt-withdraw-detail class="pt-withdraw-detail__withData" :withdrawalDetail="withdrawalDetail" @withdrawalComplete="withdrawalComplete"
  :completeLoading="completeLoading" @getWithdrawalDetail="getWithdrawalDetail" :returnLoading="returnLoading"
  @addUserWalletBalance="addUserWalletBalance"></pt-withdraw-detail>
</template>

<script>
import PtWithdrawDetail from './index'
export default {
  name: 'pt-withdraw-detail__withData',
  components: {
    'pt-withdraw-detail': PtWithdrawDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      withdrawalDetail: {},
      completeLoading: false,
      returnLoading: false
    }
  },
  methods: {
    addUserWalletBalance () {
      let data = {
        withDrawLogId: this.id
      }
      this.returnLoading = true
      this.$store.dispatch('addUserWalletBalance', data).then(res => {
        this.$message.success('回退数据成功')
        this.returnLoading = false
        this.getWithdrawalDetail()
      }).catch(err => {
        this.returnLoading = false
        this.$message.error(err || '回退数据失败')
      })
    },
    getWithdrawalDetail () {
      this.$store.dispatch('withdrawalDetail', this.id).then(res => {
        this.withdrawalDetail = res
      }).catch(err => {
        this.$message.console.error(err || '获取提现详情失败')
      })
    },
    withdrawalComplete () {
      let ids = []
      ids.push(this.id)
      this.completeLoading = true
      this.$store.dispatch('withdrawalComplete', ids).then(res => {
        this.completeLoading = false
        this.$message.success('审核提现成功')
        this.getWithdrawalDetail()
      }).catch(err => {
        this.completeLoading = false
        this.$message.error(err || '审核提现失败')
      })
    }
  },
  created () {
    this.getWithdrawalDetail()
  }
}
</script>
